import React, { Component } from "react"
import { Col, Grid, Nav, NavItem, Row } from "react-bootstrap"
import FilterSidebar from "./components/FilterSidebar"
import axios from "axios"
import getServerURL from "../../../functions/getServerURL"
import DataAccessRequestList from "./components/DataAccessRequestList"
import DataSourceList from "./components/DataSourceList"
import "./style.css"
import swal from "sweetalert";


class DataAccessRequestManager extends Component {
  state = {
    activeTab: "pending",
    pendingTabFilters: {
      selectedClients: [],
      selectedDataSources: [],
      selectedUsers: [],
      entriesPerPage: 10,
      currentPage: 1
    },
    approvedTabFilters: {
      selectedClients: [],
      selectedDataSources: [],
      selectedUsers: [],
      entriesPerPage: 10,
      currentPage: 1
    },
    dataSourcesTabFilters: {
      name: "",
      selectedClients: [],
      entriesPerPage: 10,
      currentPage: 1
    },
    requests: [],
    fetchingRequests: false,
    dataSources: [],
    fetchingDataSources: false
  }

  getEntries = (activeTab) => {
    if (["approved", "pending"].includes(activeTab)) {
      this.getRequests()
    } else {
      this.getDataSources()
    }
  }

  handleChangeTab = (e) => {
    const activeTab = e.target.name
    this.setState({ activeTab }, () => {
      this.getEntries(activeTab)
    })
  }

  handleRequestActions = (method, requestUrl) => {
    swal({
      text: `${method === "delete" ? "Deleting" : "Approving"} request... Please stand by.`,
      icon: require("../../../static/images/spinner.gif"),
      button: false
    })

    const requestParams = {
      method: method,
      url: requestUrl,
      headers: {"Authorization": `Bearer ${localStorage.getItem("token")}`}
    }

    if (method.toLowerCase() === "patch") {
      requestParams.data = { approved: true }
    }

    axios(requestParams).then(response => {
      swal({
        title: "Success",
        text: `Request has been ${method === "delete" ? "deleted" : "approved"} successfully`,
        icon: "success",
        button: "Continue",
      })
      this.getRequests(1)
    }).catch(error => {
      console.log(error.response)
      swal({
        title: "Error",
        text: `There was an issue in ${method === "delete" ? "deleting" : "approving"} the request`,
        icon: "error",
        button: "Continue",
      })
    })
  }

  handleChangeFilters = (field, value) => {
    const { activeTab } = this.state
    const filterTab = `${activeTab}TabFilters`
    this.setState({
      [filterTab]: {
        ...this.state[filterTab],
        [field]: value,
        currentPage: 1
      }
    }, () => {
      this.getEntries(activeTab)
    })
  }

  getRequests = (page = null) => {
    const { activeTab } = this.state
    const filterType = `${activeTab}TabFilters`
    const selectedClients = this.state[filterType].selectedClients
    const selectedDataSources = this.state[filterType].selectedDataSources
    const selectedUsers = this.state[filterType].selectedUsers
    const entriesPerPage = this.state[filterType].entriesPerPage
    const currentPage = page || this.state[filterType].currentPage

    this.setState({ fetchingRequests: true }, () => {
      axios.get(`${getServerURL()}access-requests/`, {
        params: {
          "approved": activeTab === "approved",
          "clients": selectedClients.map(client => client.id),
          "data_sources": selectedDataSources.map(dataSource => dataSource.id),
          "users": selectedUsers.map(user => user.id),
          "limit": entriesPerPage,
          "offset": entriesPerPage * (currentPage - 1)
        },
        headers: { "Authorization": `Bearer ${localStorage.getItem("token")}` }
      }).then(response => {
        this.setState({
          requests: response.data.results,
          [filterType]: {
            ...this.state[filterType],
            numberOfPages: Math.ceil(response.data.count / entriesPerPage),
            currentPage: currentPage
          }
        })
      }).catch(error => {
        console.log(error, error.response)
      }).finally(() => {
        this.setState({ fetchingRequests: false })
      })
    })
  }

  getDataSources = (page = null) => {
    const { activeTab } = this.state
    const filterType = `${activeTab}TabFilters`
    const name = this.state[filterType].name
    const selectedClients = this.state[filterType].selectedClients
    const entriesPerPage = this.state[filterType].entriesPerPage
    const currentPage = page || this.state[filterType].currentPage

    this.setState({ fetchingDataSources: true }, () => {
      axios.get(`${getServerURL()}access-request-data-sources/`, {
        params: {
          "name": name,
          "clients": selectedClients.map(client => client.id),
          "limit": entriesPerPage,
          "offset": entriesPerPage * (currentPage - 1)
        },
        headers: { "Authorization": `Bearer ${localStorage.getItem("token")}` }
      }).then(response => {
        this.setState({
          dataSources: response.data.results,
          [filterType]: {
            ...this.state[filterType],
            numberOfPages: Math.ceil(response.data.count / entriesPerPage),
            currentPage: currentPage
          }
        })
      }).catch(error => {
        console.log(error, error.response)
      }).finally(() => {
        this.setState({ fetchingDataSources: false })
      })
    })
  }

  componentDidMount() {
    const { activeTab } = this.state
    if (["approved", "pending"].includes(activeTab)) {
      this.getRequests()
    } else {
      this.getDataSources()
    }
  }

  render() {
    const { activeTab, fetchingRequests, fetchingDataSources, requests, dataSources } = this.state
    const filterType = `${activeTab}TabFilters`
    return (
      <div id="DataAccessRequestManager">
        <Grid>
          <Row>
            <Col xs={12} md={3}>
              <FilterSidebar
                activeTab={ activeTab }
                handleChangeFilters={ this.handleChangeFilters }
                fetchingRequests={ fetchingRequests }
                fetchingDataSources={ fetchingDataSources }
                getDataSources={ this.getDataSources }
                { ...this.state[filterType] }
              />
            </Col>
            <Col xs={12} sm={12} md={9} lg={9}>
              <Row>
                <Nav
                  bsStyle="tabs"
                  activeKey={ activeTab }
                >
                  <NavItem
                    eventKey="pending"
                    title="Pending Requests"
                    name="pending"
                    onClick={ this.handleChangeTab }
                  >
                    Pending Requests
                  </NavItem>
                  <NavItem
                    eventKey="approved"
                    title="Approved Requests"
                    name="approved"
                    onClick={ this.handleChangeTab }
                  >
                    Approved Requests
                  </NavItem>
                  <NavItem
                    eventKey="dataSources"
                    title="Data Sources"
                    name="dataSources"
                    onClick={ this.handleChangeTab }
                  >
                    Data Sources
                  </NavItem>
                </Nav>
              </Row>
              <Row>
                { fetchingRequests || fetchingDataSources ?
                  <center>
                    <div id="not-found">
                      <img alt="loader" src={require("../../../static/images/spinner.gif")} />
                    </div>
                  </center>
                  :
                  <React.Fragment>
                    { activeTab === "dataSources" ?
                      <DataSourceList
                        activeTab={ activeTab }
                        dataSources={ dataSources }
                        numberOfPages={ this.state[filterType].numberOfPages }
                        currentPage={ this.state[filterType].currentPage }
                        buttonsPerPage={ 5 }
                        getDataSources={ this.getDataSources }
                      />
                      :
                      <DataAccessRequestList
                        activeTab={ activeTab }
                        requests={ requests }
                        numberOfPages={ this.state[filterType].numberOfPages }
                        currentPage={ this.state[filterType].currentPage }
                        buttonsPerPage={ 5 }
                        getRequests={ this.getRequests }
                        handleRequestActions={ this.handleRequestActions }
                      />
                    }
                  </React.Fragment>
                }
              </Row>
            </Col>
          </Row>
        </Grid>
      </div>
    )
  }
}


export default DataAccessRequestManager


// WEBPACK FOOTER //
// ./src/routes/data-access-request/DataAccessRequestManager/index.js